import type { GlutenCounts } from "../../src/types";

interface Props {
  counts: GlutenCounts;
  total: number;
}

export function GlutenBar({ counts, total }: Props) {
  const pct = (n: number) => (total > 0 ? (n / total) * 100 : 0);
  return (
    <div
      className="flex h-[6px] rounded-full overflow-hidden bg-(--color-line-2)"
      role="img"
      aria-label={`${counts.free} naturally GF, ${counts.marked} marked GF, ${counts.unknown} ask, ${counts.contains} contain gluten`}
    >
      <div className="gbar-seg h-full bg-(--color-ok)" style={{ width: `${pct(counts.free)}%` }} />
      <div
        className="gbar-seg h-full bg-(--color-ok-marked)"
        style={{ width: `${pct(counts.marked)}%` }}
      />
      <div
        className="gbar-seg h-full bg-(--color-warn)"
        style={{ width: `${pct(counts.unknown)}%` }}
      />
      <div
        className="gbar-seg h-full bg-(--color-contains-bar)"
        style={{ width: `${pct(counts.contains)}%` }}
      />
    </div>
  );
}
